import React, { useState } from 'react';
import { Lock, ShieldCheck, Mail, Clock, CheckCircle2, Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const PAYMENT_URL = 'https://pagos.digipromarket.com/cart/56229348835654:1';
const PAYMENT_URL_UPSELL = 'https://pagos.digipromarket.com/cart/56229516345670:1';
export function FinalCTA() {
  const [hasUpsell, setHasUpsell] = useState(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(36000);
  const totalSavings = hasUpsell ? '94,93€' : '89,93€';
  return <section className="bg-gradient-to-b from-navy to-navyDark py-20 px-4 text-white" data-id="element-14">
      <div className="max-w-4xl mx-auto text-center" data-id="element-15">
        <h2 className="text-4xl md:text-5xl font-heading mb-8 drop-shadow-lg" data-id="element-16">
          "Esta Es Tu Oportunidad De Empezar Esta Noche"
        </h2>

        <div className="text-lg md:text-xl text-white/80 space-y-6 mb-12 max-w-3xl mx-auto text-left" data-id="element-17">
          <p data-id="element-18">Tienes dos opciones.</p>
          <p data-id="element-19">
            La primera: cerrar esta página, seguir improvisando las cenas,
            seguir mirando la báscula con frustración y esperar que algo cambie
            solo.
          </p>
          <p data-id="element-20">
            La segunda: invertir menos de lo que cuesta una cena para dos en un
            restaurante mediocre, y tener esta noche mismo un sistema completo,
            probado por más de 1.200 personas, creado por una nutricionista
            clínica con 12 años de experiencia.
          </p>
          <p data-id="element-21">
            En 10 minutos puedes tener tu primera cena del sistema en la mesa.
          </p>
          <p className="text-2xl font-bold text-white text-center mt-8" data-id="element-22">
            El cambio no empieza el lunes.
            <br data-id="element-23" />
            <span className="text-gold" data-id="element-24">Empieza esta noche.</span>
          </p>
        </div>

        {/* Mini Value Stack */}
        <div className="bg-white/10 border border-white/20 rounded-3xl p-6 md:p-8 max-w-2xl mx-auto mb-6 backdrop-blur-sm" data-id="element-25">
          <table className="w-full text-left border-collapse mb-6" data-id="element-26">
            <tbody data-id="element-27">
              <tr className="border-b border-white/10" data-id="element-28">
                <td className="py-3 text-white/80" data-id="element-29">✅ 5 Tomos completos</td>
                <td className="py-3 text-right text-white/60" data-id="element-30">79,95€</td>
              </tr>
              <tr className="border-b border-white/10" data-id="element-31">
                <td className="py-3 text-white/80" data-id="element-32">✅ 3 Bonos exclusivos</td>
                <td className="py-3 text-right text-white/60" data-id="element-33">29,97€</td>
              </tr>
              <tr data-id="element-34">
                <td className="py-3 text-white/60" data-id="element-35">Valor total</td>
                <td className="py-3 text-right text-white/40 line-through" data-id="element-36">
                  109,92€
                </td>
              </tr>
            </tbody>
          </table>

          {/* Upsell Bump */}
          <div onClick={() => setHasUpsell(!hasUpsell)} className={`
              cursor-pointer rounded-2xl border-2 border-dashed p-4 mb-6 transition-all duration-300 text-left
              ${hasUpsell ? 'border-gold bg-white/10' : 'border-white/20 bg-white/5 hover:bg-white/10'}
            `} data-id="element-37">
            <div className="flex items-start gap-3" data-id="element-38">
              <div className={`
                  w-6 h-6 rounded-md border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors
                  ${hasUpsell ? 'bg-gold border-gold text-navy' : 'border-white/40 bg-transparent'}
                `} data-id="element-39">
                {hasUpsell && <CheckCircle2 className="w-4 h-4" data-id="element-40" />}
              </div>

              <div className="flex-1" data-id="element-41">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-42">
                  <Zap className="w-4 h-4 text-gold" data-id="element-43" />
                  <span className="font-bold text-white text-sm" data-id="element-44">
                    ⚡ AÑADIR: Kit Acelerador "Vientre Plano" (+5€)
                  </span>
                </div>
                <ul className="space-y-1" data-id="element-45">
                  <li className="flex items-start gap-2 text-xs text-white/60" data-id="element-46">
                    <CheckCircle2 className="w-3.5 h-3.5 text-gold/70 flex-shrink-0 mt-0.5" data-id="element-47" />
                    <span data-id="element-48">Protocolo 21 Días "Vientre Plano" en 3 fases</span>
                  </li>
                  <li className="flex items-start gap-2 text-xs text-white/60" data-id="element-49">
                    <CheckCircle2 className="w-3.5 h-3.5 text-gold/70 flex-shrink-0 mt-0.5" data-id="element-50" />
                    <span data-id="element-51">
                      7 Bebidas Metabólicas Nocturnas + Auditoría
                      anti-estancamiento
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-xs text-white/60" data-id="element-52">
                    <CheckCircle2 className="w-3.5 h-3.5 text-gold/70 flex-shrink-0 mt-0.5" data-id="element-53" />
                    <span data-id="element-54">
                      Los 7 Saboteadores Saludables que frenan tu abdomen
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Price */}
          <div className="text-center mb-2" data-id="element-55">
            <span className="block text-white/60 text-sm mb-1" data-id="element-56">
              TÚ PAGAS HOY
            </span>
            <span className="text-5xl md:text-6xl font-heading font-bold text-gold drop-shadow-lg" data-id="element-57">
              {hasUpsell ? '24,99€' : '19,99€'}
            </span>
            <span className="block mt-2" data-id="element-58">
              <span className="inline-block bg-teal text-white text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-59">
                Ahorras {totalSavings} hoy
              </span>
            </span>
          </div>
        </div>

        <div className="mb-8 flex items-center justify-center gap-3 text-xl font-bold text-gold" data-id="element-60">
          <Clock className="w-6 h-6 animate-pulse" data-id="element-61" />
          <span data-id="element-62">
            OFERTA EXPIRA EN: {hours}:{minutes}:{seconds}
          </span>
        </div>

        <div className="max-w-xl mx-auto space-y-4" data-id="element-63">
          {/* Payment Button */}
          <a href={hasUpsell ? PAYMENT_URL_UPSELL : PAYMENT_URL} className="block w-full" data-id="element-64">
            <div className="w-full bg-gold hover:bg-goldDark text-white font-bold text-center px-8 py-5 rounded-2xl shadow-2xl transition-all duration-300 animate-cta-pulse border-4 border-gold/30 hover:border-goldDark/30" data-id="element-65">
              <span className="text-xl md:text-2xl block mb-1 drop-shadow-sm" data-id="element-66">
                🔥{' '}
                {hasUpsell ? 'QUIERO EL PACK + KIT POR 24,99€' : 'QUIERO EL PACK COMPLETO POR 19,99€'}
              </span>
              <span className="text-sm font-medium opacity-90" data-id="element-67">
                (Acceso inmediato · Garantía 7 días · Pago seguro)
              </span>
            </div>
          </a>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 text-xs md:text-sm text-white/60 font-medium" data-id="element-68">
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-69">
              <Lock className="w-5 h-5 text-white/40" data-id="element-70" />
              <span data-id="element-71">
                Pago 100% seguro
                <br data-id="element-72" />
                SSL encriptado
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-73">
              <Clock className="w-5 h-5 text-white/40" data-id="element-74" />
              <span data-id="element-75">
                Acceso inmediato
                <br data-id="element-76" />
                tras el pago
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-77">
              <ShieldCheck className="w-5 h-5 text-white/40" data-id="element-78" />
              <span data-id="element-79">
                Garantía devolución
                <br data-id="element-80" />7 días sin preguntas
              </span>
            </div>
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-81">
              <Mail className="w-5 h-5 text-white/40" data-id="element-82" />
              <span data-id="element-83">
                Soporte
                <br data-id="element-84" />
                en español
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}